import { styled, css } from "styled-components";
import { Colors } from "../../../styles";
export const QuasiRadio = styled.div `
  position: relative;
  width: 1.5rem;
  height: 1.5rem;
  min-width: 1.5rem;
  border-radius: 50%;
  box-shadow: inset 0 0 0 1px
    ${({ isChecked }) => (isChecked ? Colors.WHITE_2024 : Colors.GRAY)};
  margin-right: 0.5rem;
  transition: box-shadow 0.3s ease; /* Adding transition for smooth hover effect */

  &::after {
    position: absolute;
    content: "";
    width: 0.75rem;
    height: 0.75rem;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 50%;
  }

  ${({ isChecked }) => isChecked &&
    css `
      &::after {
        background-color: ${Colors.WHITE_2024};
      }
    `}
`;
export default QuasiRadio;
//# sourceMappingURL=QuasiRadio.js.map